import React from 'react';
import './App.css';
import FruitMachine from './FruitMachine';

function App() {
  return (
    <div className="App">
      <FruitMachine />
    </div>
  );
}

export default App;
